import api from 'api';
import {
  finishNativePurchase,
  getNativeStorePlatform,
  purchaseNative,
  restoreNativePurchases,
} from 'mobile-modules/native-billing/nativeBilling';

export const executeMobilePurchase = async (status) => {
  if (!status?.purchase || !status?.canBuy) throw new Error('This Mobile Purchase is not available.');
  const proof = await purchaseNative(status.purchase);
  const result = await api.mobileRuntime.completePurchase(proof);
  await finishNativePurchase(proof, status.purchase);
  return result;
};

// Google Play can complete payment while the WebView is killed or while the backend is
// temporarily unavailable. Restore owned purchases before rendering the entitlement gate,
// grant them idempotently on the backend, then consume/acknowledge only after that grant.
export const recoverMobilePurchases = async (status) => {
  if (getNativeStorePlatform() !== 'google' || !status?.purchase) {
    return { recovered: 0, status };
  }
  if (status.purchaseProductType === 'product') return { recovered: 0, status };

  const expectedProductId = String(status.purchase.googleProductId || '').trim();
  if (!expectedProductId) return { recovered: 0, status };

  const owned = await restoreNativePurchases();
  const matching = owned.filter(item => String(item?.productId || '') === expectedProductId);
  let nextStatus = status;
  let recovered = 0;

  for (const item of matching) {
    const proof = {
      ...item,
      platform: 'google',
      productId: expectedProductId,
    };
    nextStatus = await api.mobileRuntime.completePurchase(proof);
    await finishNativePurchase(proof, status.purchase);
    recovered += 1;
  }

  return { recovered, status: nextStatus };
};

const showInfo = (message) => new Promise((resolve) => {
  if (window.Modals?.showInfo) {
    window.Modals.showInfo({ message, okHandler: resolve });
    return;
  }
  window.alert(message); // eslint-disable-line no-alert
  resolve();
});

export const notifyMobilePurchaseComplete = async (result, translate) => {
  const type = result?.purchaseProductType;
  if (type === 'custom_content') {
    const level = Number(result?.generatedCustomContentLevel?.customLevelIndex || result?.currentCustomLevelIndex || 1);
    const template = typeof translate === 'function'
      ? translate(3844, 'Custom Level {{level}} created.', true)
      : 'Custom Level {{level}} created.';
    await showInfo(String(template || 'Custom Level {{level}} created.').replace(/\{\{\s*level\s*\}\}/gi, String(level)));
  } else if (type === 'subscription' || type === 'org_subscription') {
    const message = typeof translate === 'function'
      ? translate(3851, 'Subscription renewed.', true)
      : 'Subscription renewed.';
    await showInfo(message || 'Subscription renewed.');
  }
  window.location.reload();
};
